module.exports = __webpack_public_path__ + "img/Qualification_8.cbbf58b1.jpg";